import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES, LOCATIONS } from "../data/content";
import { MARKETS } from "../data/markets";
import { INDUSTRIES } from "../data/industries";
import { WA_NUMBER_DISPLAY, waLink, CONTEXT_MESSAGES } from "../lib/whatsapp";
import { track } from "../lib/analytics";

export default function Footer() {
  return (
    <footer className="border-t border-line bg-obsidian" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:px-16">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-4">
            <p className="font-display text-lg font-extrabold tracking-[0.15em]">GROTECH WEB</p>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/50">
              Websites that don't just look good. Websites that help your business get found — and turn visitors into enquiries.
            </p>
            <a
              href={waLink(CONTEXT_MESSAGES.general)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              onClick={() => track("whatsapp_click", { location: "footer" })}
              className="mt-6 inline-flex items-center gap-2 text-sm text-ember transition-colors hover:text-ember-hover"
            >
              {WA_NUMBER_DISPLAY} <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-white/40">Services</p>
            <ul className="mt-4 space-y-2.5">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link to={`/${s.slug}/`} className="text-sm text-white/60 transition-colors hover:text-white">
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-white/40">Explore</p>
            <ul className="mt-4 space-y-2.5">
              <li><Link to="/services/" className="text-sm text-white/60 hover:text-white">All Services</Link></li>
              <li><Link to="/pricing/" className="text-sm text-white/60 hover:text-white">Pricing</Link></li>
              <li><Link to="/contact/" className="text-sm text-white/60 hover:text-white">Contact</Link></li>
              <li><Link to="/projects/" className="text-sm text-white/60 hover:text-white">Recent Work</Link></li>
              <li><Link to="/reviews/" className="text-sm text-white/60 hover:text-white">Reviews</Link></li>
              <li><Link to="/about/" className="text-sm text-white/60 hover:text-white">About Us</Link></li>
              <li><Link to="/blog/" className="text-sm text-white/60 hover:text-white">Insights</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-white/40">Locations Served</p>
            <ul className="mt-4 space-y-2.5">
              {LOCATIONS.filter((l) => l.label).map((l) => (
                <li key={l.slug}>
                  <Link to={`/${l.slug}/`} className="text-sm text-white/60 transition-colors hover:text-white">
                    {l.label}
                  </Link>
                </li>
              ))}
              {MARKETS.filter((m) => m.service === "Website Development").map((m) => (
                <li key={m.slug}>
                  <Link to={`/${m.slug}/`} className="text-sm text-white/60 transition-colors hover:text-white">
                    Website Development {m.city || (m.country === "United States" ? "USA" : m.country)}
                  </Link>
                </li>
              ))}
              <li className="text-sm text-white/40">Working remotely across India, the USA and the UAE</li>
            </ul>
          </div>
        </div>
        <div className="mt-12 grid gap-8 border-t border-white/10 pt-10 md:grid-cols-2">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-white/40">By country</p>
            <ul className="mt-4 flex flex-wrap gap-x-5 gap-y-2">
              {MARKETS.filter((m) => m.service !== "Website Development").map((m) => (
                <li key={m.slug}>
                  <Link to={`/${m.slug}/`} className="inline-block py-1 text-sm text-white/55 hover:text-white">{m.heroTitle}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-white/40">By industry</p>
            <ul className="mt-4 flex flex-wrap gap-x-5 gap-y-2">
              {INDUSTRIES.map((i) => (
                <li key={i.slug}>
                  <Link to={`/website-development-for-${i.slug}/`} className="inline-block py-1 text-sm text-white/55 hover:text-white">{i.heroTitle}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-white/35">© {new Date().getFullYear()} Grotech Web. Websites built to bring you business.</p>
          <div className="flex items-center gap-4">
            <Link to="/privacy-policy/" className="text-xs text-white/35 hover:text-white/60">Privacy Policy</Link>
            <Link to="/terms/" className="text-xs text-white/35 hover:text-white/60">Terms</Link>
          </div>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/35">Build once. Grow continuously.</p>
        </div>
      </div>
    </footer>
  );
}
